import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { useState } from "react";
import { MdFileDownload } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";

const IncentivesSuper = () => {
  const [activeTab, setActiveTab] = useState("all");

  const tabs = [
    { key: "all", label: "All Incentives" },
    { key: "offers", label: "Offers" },
    { key: "coupons", label: "Coupons" },
    { key: "discount", label: "Discount" }, // Changed from Expired to Discount
  ];

  const filteredData = () => {
    switch (activeTab) {
      case "offers":
        return data.filter((item) => item.type === "Offer");
      case "coupons":
        return data.filter((item) => item.type === "Coupon");
      case "discount":
        return data.filter((item) => item.type === "Discount");
      default:
        return data;
    }
  };

  return (
    <Wrapper>
      <div className="container py-5">
        <div className="card border-0 shadow-sm p-4">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
            <div>
              <h4 className="text-dark mb-1">Incentives Management</h4>
              <p className="text-muted mb-0">
                Manage offer discounts and coupons to drive sales
              </p>
            </div>
            <button className="btn btn-primary d-flex align-items-center">
              <MdFileDownload className="me-2" size={20} />
              Create New Incentive
            </button>
          </div>

          <ul className="nav nav-pills nav-justified mb-3" role="tablist">
            {tabs.map((tab) => (
              <li className="nav-item" role="presentation" key={tab.key}>
                <button
                  className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                  onClick={() => setActiveTab(tab.key)}
                  type="button"
                  role="tab"
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content">
            <div className="tab-pane fade show active" role="tabpanel">
              <TableWrapper>
                <table className="table table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Name / Code</th>
                      <th>Description</th>
                      <th>Type</th>
                      <th>Value</th>
                      <th>Validity</th>
                      <th>Status</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData().map((item, index) => (
                      <tr key={index}>
                        <td><strong>{item.name}</strong></td>
                        <td>{item.description}</td>
                        <td><span className={`badge ${item.badgeClass}`}>{item.type}</span></td>
                        <td>{item.value}</td>
                        <td>{item.validity}</td>
                        <td><span className={`badge ${item.statusClass}`}>{item.status}</span></td>
                        <td className="text-center">
                          <BsThreeDotsVertical size={20} style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </TableWrapper>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default IncentivesSuper;

const data = [
  {
    name: "Summer Weekend Offer",
    description: "Special rates for weekend bookings.",
    type: "Offer",
    badgeClass: "bg-primary-subtle text-primary",
    value: "15% Off",
    validity: "Jun 1, 2024 - Aug 31, 2024",
    status: "Active",
    statusClass: "bg-success-subtle text-success",
  },
  {
    name: "Early Bird Discount",
    description: "Discount for bookings made 30 days in advance.",
    type: "Offer",
    badgeClass: "bg-purple",
    value: "10% Off",
    validity: "Jan 1, 2024 - Dec 31, 2024",
    status: "Active",
    statusClass: "bg-success-subtle text-success",
  },
  {
    name: "WELCOME20",
    description: "20% off first booking for new users.",
    type: "Coupon",
    badgeClass: "bg-info-subtle text-info",
    value: "20% Off",
    validity: "May 1, 2024 - Sep 30, 2024",
    status: "Active",
    statusClass: "bg-success-subtle text-success",
  },
  {
    name: "Exclusive Discount Deal",
    description: "Special discount on select products.",
    type: "Discount",
    badgeClass: "bg-warning-subtle text-warning",
    value: "25% Off",
    validity: "Jul 1, 2024 - Sep 30, 2024",
    status: "Active",
    statusClass: "bg-success-subtle text-success",
  },
];

const Wrapper = styled.div``;

const TableWrapper = styled.div`
  .badge {
    padding: 6px 12px;
    font-size: 0.75rem;
    border-radius: 12px;
    font-weight: 500;
  }

  .table td,
  .table th {
    vertical-align: middle;
    text-align: center;
  }

  .bg-purple {
    background-color: rgba(155, 89, 182, 0.15);
    color: #9b59b6;
  }

  ul.nav-pills {
    border-bottom: 1px solid #dee2e6;
  }

  .nav-pills .nav-link {
    width: 100%;
    font-weight: 500;
    padding: 0.5rem 1rem;
  }

  .nav-pills .nav-link.active {
    background-color: #0d6efd;
    color: #fff;
  }
`;
